import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as styles from './SocialMediaSummary.scss';

var humanFormat = require('human-format');

var numberFormatScale = new humanFormat.Scale({
  '': 1,
  k: 1000,
  M: 1000000,
  B: 1000000000,
  T: 1000000000000
});
var AdPerformanceStats = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdPerformanceStats, _Component);

  var _super = _createSuper(AdPerformanceStats);

  function AdPerformanceStats(props) {
    var _this;

    _classCallCheck(this, AdPerformanceStats);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatNumber", function (num) {
      if (num > 9999) {
        return humanFormat(num, {
          scale: numberFormatScale
        });
      }

      return Number(num).toLocaleString();
    });

    _defineProperty(_assertThisInitialized(_this), "getActionItems", function () {
      var insights = _this.props.adDetails.insights;
      var adType = _this.props.adDetails.campaign.objective;
      var items = [];

      if (insights.hasOwnProperty('cost_per_action_type') && insights.hasOwnProperty('actions')) {
        if (adType === 'LEAD_GENERATION') {
          var costObj = _.find(insights.cost_per_action_type, {
            action_type: 'leadgen.other'
          });

          var actionObj = _.find(insights.actions, {
            action_type: 'leadgen.other'
          });

          var costValue = costObj ? costObj.value : 0;
          items.push({
            text: actionObj && parseInt(actionObj.value, 10) === 1 ? 'Lead' : 'Leads',
            value: actionObj ? actionObj.value : 0
          });
          items.push({
            text: 'Per Lead',
            value: costValue ? _this.formatDollars(parseFloat(costValue)) : '$0'
          });
        } else if (adType === 'POST_ENGAGEMENT') {
          var _costObj = _.find(insights.cost_per_action_type, {
            action_type: 'post_engagement'
          });

          var _actionObj = _.find(insights.actions, {
            action_type: 'post_engagement'
          });

          var _costValue = _costObj ? _costObj.value : 0;

          items.push({
            text: _actionObj && parseInt(_actionObj.value, 10) === 1 ? 'Engagement' : 'Engagements',
            value: _actionObj ? _actionObj.value : 0
          });
          items.push({
            text: 'Per Engagement',
            value: _costValue ? _this.formatDollars(parseFloat(_costValue)) : '$0'
          });
        } else if (adType === 'PAGE_LIKES') {
          var _costObj2 = _.find(insights.cost_per_action_type, {
            action_type: 'like'
          });

          var _actionObj2 = _.find(insights.actions, {
            action_type: 'like'
          });

          var _costValue2 = _costObj2 ? _costObj2.value : 0;

          items.push({
            text: _actionObj2 && parseInt(_actionObj2.value, 10) === 1 ? 'Page Like' : 'Page Likes',
            value: _actionObj2 ? _actionObj2.value : 0
          });
          items.push({
            text: 'Per Like',
            value: _costValue2 ? _this.formatDollars(parseFloat(_costValue2)) : '$0'
          });
        } else if (adType === 'LINK_CLICKS') {
          var _costObj3 = _.find(insights.cost_per_action_type, {
            action_type: 'link_click'
          });

          var _actionObj3 = _.find(insights.actions, {
            action_type: 'link_click'
          });

          var _costValue3 = _costObj3 ? _costObj3.value : null;

          items.push({
            text: _actionObj3 && parseInt(_actionObj3.value, 10) === 1 ? 'Link Click' : 'Link Clicks',
            value: _actionObj3 ? _actionObj3.value : 0
          });
          items.push({
            text: 'Per Click',
            value: _costValue3 ? _this.formatDollars(parseFloat(_costValue3)) : '$0'
          });
        } else if (adType === 'VIDEO_VIEWS') {
          var _costObj4 = _.find(insights.cost_per_action_type, {
            action_type: 'video_view'
          });

          var _actionObj4 = _.find(insights.actions, {
            action_type: 'video_view'
          });

          var _costValue4 = _costObj4 ? _costObj4.value : 0;

          items.push({
            text: _actionObj4 && parseInt(_actionObj4.value === 1, 10) ? 'View' : 'Views',
            value: _actionObj4 ? _actionObj4.value : 0
          });
          items.push({
            text: 'Per View',
            value: _costValue4 ? _this.formatDollars(parseFloat(_costValue4)) : '$0'
          });
        }
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionalItems", function () {
      var insights = _this.props.adDetails.insights;
      var items = [];

      _this.props.optionalFields.forEach(function (field) {
        if (_this.props.adDetails.campaign.objective.includes(field.toUpperCase())) {
          return;
        }

        var item = _.find(insights.actions, {
          action_type: field
        });

        if (item) {
          var pluralify = parseInt(item.value, 10) !== 1;

          var keyName = _this.translateKeyToName(field, pluralify);

          items.push({
            text: keyName,
            value: item.value
          });
        }
      });

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "getOtherItems", function () {
      var adDetails = _this.props.adDetails;
      var insights = adDetails.insights;
      var convertedItems = [];

      _this.props.otherFields.forEach(function (item) {
        if (!insights.hasOwnProperty(item)) {
          return false;
        }

        var itemName = _this.translateKeyToName(item);

        var itemValue = typeof insights[item] === 'number' ? _this.formatDollars(insights[item]) : _this.formatNumber(parseInt(insights[item]));
        convertedItems.push({
          text: itemName,
          value: itemValue
        });
      });

      return convertedItems;
    });

    _defineProperty(_assertThisInitialized(_this), "formatDollars", function (val) {
      return "$".concat(val.toFixed(2));
    });

    _defineProperty(_assertThisInitialized(_this), "translateKeyToName", function (key, pluralify) {
      return pluralify ? "".concat(_.startCase(key), "s") : _.startCase(key);
    });

    return _this;
  }

  _createClass(AdPerformanceStats, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var theme = this.props.theme;
      var actionItems = this.getActionItems();
      var otherItems = this.getOtherItems();
      var optionalItems = this.getOptionalItems();
      var allItems = actionItems.concat(otherItems, optionalItems);
      var listItems = allItems.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: styles.overviewListItem,
          key: index
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.largeText,
          style: {
            color: theme.colors.secondaryColor
          }
        }, item.value), /*#__PURE__*/React.createElement("span", {
          className: styles.smallText
        }, item.text));
      });
      return /*#__PURE__*/React.createElement("ul", {
        className: styles.listStyle
      }, listItems);
    }
  }]);

  return AdPerformanceStats;
}(Component), _defineProperty(_class2, "defaultProps", {
  listStyle: {},
  style: {},
  otherFields: ['impressions', 'reach', 'spend'],
  optionalFields: ['post_reaction', 'post_engagement', 'link_click', 'like', 'comment', 'share']
}), _temp)) || _class);
export default AdPerformanceStats;